import React from "react";

export default ({ ...modifiers }) => {
  let className = "loader";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <div className={className}>
      <div className="loader_dot"></div>
      <div className="loader_dot"></div>
      <div className="loader_dot"></div>
      <div className="loader_dot"></div>
      <div className="loader_dot"></div>
    </div>
  );
};
